import { Endpoints } from "constants/endpoints";
import type { Mandat, MandatSdeaCreateModel } from "models";
import { elusApiClient } from "./apiClients";
import type { Operation } from "fast-json-patch";

interface MandatsQueryFilter {
  communesIds?: Array<string>;
  perimetresIds?: Array<string>;
  territoiresIds?: Array<string>;
  fonctionsIds?: Array<string>;
  isActive?: boolean;
}

function isStringifiable(value: unknown): value is { toString: () => string } {
  return value != null && typeof value.toString === "function";
}

/**
 * Créée un mandat SDEA
 * @param data les données du mandat à créer
 * @returns le mandat créé
 */
async function create(data: MandatSdeaCreateModel): Promise<Mandat> {
  const url = Endpoints.MANDATS;
  return elusApiClient.post(url, data);
}

async function patch(idMandat: string, patchData: Array<Operation>): Promise<Mandat> {
  const url = `${Endpoints.MANDATS}/${idMandat}`;
  return elusApiClient.patch(url, patchData);
}

async function deleteMandat(idMandat: string): Promise<void> {
  const url = `${Endpoints.MANDATS}/${idMandat}`;
  return elusApiClient.delete(url);
}

/**
 * Récupère les contacts métiers correspondant à plusieurs filtres, rangés par ordre alphabétique de métier
 * @returns PageableDto<Array<ContactMetierTerritoire>
 */
async function getByFilter(filter: MandatsQueryFilter = {}): Promise<Array<Mandat>> {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filter)) {
    if (Array.isArray(value) && value.length > 0) {
      params.append(key, value.join(","));
    } else if (isStringifiable(value)) {
      params.append(key, value.toString());
    }
  }

  const queryString = params.size > 0 ? `?${params.toString()}` : "";

  const url = `${Endpoints.MANDATS}${queryString}`;
  return await elusApiClient.get<Array<Mandat>, Array<Mandat>>(url);
}

export const mandatsService = {
  create,
  deleteMandat,
  getByFilter,
  patch,
};
